






































































































































































































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import { EventBus } from "@/eventbus";
import { CopyUrl } from "@/common/clipboard";
import { computed, ref } from "@vue/composition-api";
import { UseModal } from "@/components/root/modal";
import FileDetailsModalVue from "@/components/modals/FileDetailsModal.vue";
import EmptyCell from "@/components/EmptyCell.vue";
import { UsePopup } from "@/components/root/popup/popup.state";
import { InformationType } from "@/common/models";
import { remToPx } from "@/common/dom.functions";
export default Vue.extend({
  props: ["source"],
  components: {
    AppTableRow,
    SensitivityLabel,
    EmptyCell,
  },
  setup(props) {
    const showLoader = ref(false);

    const showMenu = (event: MouseEvent) =>
      EventBus.emit("showEntityMenu", { item: props.source, event });

    const context_labels_tooltip_data = computed(() => {
      // @ts-ignore
      const { context } = props.source;
      return ["Context Labels", ...context.map((d: any) => d.name)];
    });

    const toolipData = computed(() => {
      // @ts-ignore
      const { exposedPersonCount, someExposedToRefs } = props.source.details;
      const res = [
        "Exposed To",
        ...someExposedToRefs.map((d: any) => d.emailAddress),
      ];
      const diff = exposedPersonCount - someExposedToRefs.length;
      if (diff > 0) {
        res.push(`and ${diff} more...`);
      }
      return res;
    });

    const showDetailsPopup = () => {
      // @ts-ignore
      UseModal().show(FileDetailsModalVue, { ...props.source });
    };

    const showPiisPopup = (piis: InformationType[], event: MouseEvent) => {
      UsePopup.showDisplayPopup({
        type: "TextDisplayPopup",
        event,
        items: piis.map((d) => d.labelName),
        position: "left",
        width: remToPx(30),
      });
    };

    return {
      CopyUrl,
      showMenu,
      toolipData,
      context_labels_tooltip_data,
      showDetailsPopup,
      showLoader,
      showPiisPopup,
    };
  },
});
